// import SVG from 'react-inlinesvg';
import React from "react";
import Modal from "react-modal";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import surveyModalStyles from "../../../styles/composable/survey-modal.module.scss";
import styles from "./index.module.scss";

interface IProps {
    isOpen: boolean;
    isSubmitting: boolean;
    onClose: () => void;
    onSubmit: (data: { rating: number | null }) => void;
}

const possibleRatings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const SurveyModalRateWebsite = (props: IProps): React.ReactNode => {
    const [rating, setRating] = React.useState<number | null>(null);

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        props.onSubmit({
            rating: rating,
        });
    };

    const buildRatings = () => {
        const elems = possibleRatings.map((ratingValue) => {
            // TODO(i18n): Wrap screen reader text in t tagged template: {t`This element is selected`}
            const screenReaderText =
                rating === ratingValue ? (
                    <span className="ada-screenreader-only">
                        This element is selected
                    </span>
                ) : null;
            return (
                <a
                    key={ratingValue}
                    data-rating-value={ratingValue}
                    data-rating-text={ratingValue}
                    className={
                        rating === ratingValue ? styles.brCurrent : undefined
                    }
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setRating(ratingValue);
                    }}
                >
                    {screenReaderText}
                    {ratingValue}
                </a>
            );
        });
        return elems;
    };

    return (
        <Modal
            aria={{
                modal: true,
            }}
            style={{
                content: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxHeight: "95%",
                    maxWidth: "542px",
                    width: "96%",
                    overflow: "auto",
                    padding: "40px",
                },
            }}
            // TODO(i18n): Translate contentLabel attribute with t tagged template: contentLabel={t`Survey`}
            contentLabel="Survey"
            portalClassName="locator"
            className="locations store-locator-survey modal"
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            role="dialog"
        >
            <div className={surveyModalStyles.surveyModalInner}>
                <div
                    aria-label={t`Close`}
                    className={concatClassNames([
                        surveyModalStyles.surveyModalClose,
                        "button--ghost",
                    ])}
                    onClick={props.onClose}
                >
                    <div
                        className={surveyModalStyles.surveyModalCloseIcon}
                    ></div>
                </div>
                <div className="send__content survey__carousel">
                    <h3>{richT(t`Your directions<br />are on the way…`)}</h3>
                    <p className={surveyModalStyles.surveyModalIntro}>
                        {t`One quick question. How was your online experience today?`}
                    </p>
                    <form onSubmit={onSubmit}>
                        <fieldset>
                            {/* TODO(i18n): Wrap legend text in t tagged template: {t`Rate your experience`} */}
                            <legend className="ada-screenreader-only">
                                Rate your experience
                            </legend>
                            <div className={styles.brThemeBarsSquare}>
                                <div className={styles.brWidget}>
                                    {buildRatings()}
                                </div>
                            </div>
                            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                {/* TODO(i18n): Translate value attribute with t tagged template: value={t`Continue`} */}
                                <input
                                    id="survey-cell2-submit-email"
                                    type="submit"
                                    value="Continue"
                                    className="button al-store-locator__button--continue"
                                    disabled={!rating}
                                />
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </Modal>
    );
};
